import type { ComponentLoaderType } from '@grafikr/components';
import { isbot } from 'isbot';

import { getCurrentUri, getIntendedSite, getUserCountry, isOnIntendedSite } from 'utils/geo';

const Loader: ComponentLoaderType = (_, load) => {
  (async () => {
    // Return early if user agent is a bot
    if (isbot(navigator.userAgent)) {
      return;
    }

    // Return early if already on intended site
    if (isOnIntendedSite()) {
      return;
    }

    const currentUri = getCurrentUri();

    const currentCountry = await getUserCountry();
    const regionMatch = getIntendedSite(currentCountry);

    if ('uri' in regionMatch) {
      if (regionMatch.uri !== currentUri) {
        load();
      }
    } else {
      load();
    }
  })();

  return () => {};
};

export default Loader;
